import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE } from '../constants';
import './Login.css';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${BASE}/api/v1/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (res.ok || res.status === 200) {
        setSent(true);
      } else {
        setError('Something went wrong. Please try again.');
      }
    } catch {
      setError('Unable to connect to server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lp-solo">
      <div className="lp-form">
        <div className="lp-wordmark" onClick={() => navigate('/login')}>
          <span className="lp-sq" aria-hidden />
          AGENT WORKFORCE
        </div>

        {sent ? (
          <>
            <h2 className="lp-form-title">Check your email</h2>
            <p className="lp-form-sub">
              If an account exists with <strong style={{ color: 'var(--ink)' }}>{email}</strong>, a
              password reset link has been sent. Check your inbox and spam folder.
            </p>
            <button type="button" className="lp-submit" onClick={() => navigate('/login')}>
              Back to sign in
            </button>
            <button
              type="button"
              className="lp-submit lp-submit--ghost"
              onClick={() => { setSent(false); setEmail(''); }}
            >
              Try another email
            </button>
          </>
        ) : (
          <>
            <h2 className="lp-form-title">Forgot password</h2>
            <p className="lp-form-sub">
              Enter the email associated with your account and we'll send you a link to reset your password.
            </p>

            {error && <div className="lp-msg err">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="lp-field">
                <label htmlFor="forgot-email" className="lp-label">Email</label>
                <input
                  id="forgot-email"
                  type="email"
                  className="lp-input"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  required
                  autoFocus
                  autoComplete="email"
                />
              </div>

              <button
                type="submit"
                className="lp-submit"
                disabled={loading || !email}
              >
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </form>

            <div className="lp-opts" style={{ justifyContent: 'center', marginTop: 18, marginBottom: 0 }}>
              <button type="button" className="lp-forgot" onClick={() => navigate('/login')}>
                Back to sign in
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
